import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  ShopTarifierungRequestEvents,
  TarifiereAngebotForShopAction,
} from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { CallEffect, ForkEffect, SelectEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TaasGegeData, TaasRequestModel, TaasResponseModel } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { buildTaasGegeDataForShop } from './transformer/gegeData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasGegeData
>(App.GEGE);
export const shopTarifierer = new ShopTarifierer({
  appId: App.GEGE,
  taasDataBuilder: buildTaasGegeDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungGEGE(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_GEGE,
    safeSaga(callSuccessOnMatchingAngebotsId, App.GEGE),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(callTarifierungOnMatchingAngebotsId, App.GEGE),
  );
}

export function* callTarifierungOnMatchingAngebotsId(
  tarifiereAngebotAction: TarifiereAngebotForShopAction,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const angebotsIdIsMatching = appState.angebotsId === tarifiereAngebotAction.payload.angebotsId;

  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.callTarifierung, tarifiereAngebotAction);
  }
}

export function* callSuccessOnMatchingAngebotsId(
  successAction: DoRequestResponse<TaasResponseModel, TaasRequestModel<TaasGegeData>>,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const originEvent: TarifiereAngebotForShopAction =
    successAction.doRequestAction.payload.originEvent;
  const angebotsIdIsMatching = appState.angebotsId === originEvent.payload.angebotsId;
  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.handleSuccess, successAction);
  }
}
